import React, { Suspense, lazy } from 'react';
import { useSearchParams } from 'react-router-dom';
import { BarChart3, CalendarRange, Loader2, PieChart, TrendingUp } from 'lucide-react';
import { PillTabs } from './financeBits';

// As abas carregam sob demanda (React.lazy): o recharts fica num chunk separado e só entra quando
// alguém abre um relatório.
const ExpensesReportTab = lazy(() => import('./ExpensesReportTab').then((m) => ({ default: m.ExpensesReportTab })));
const AnnualReportTab = lazy(() => import('./AnnualReportTab').then((m) => ({ default: m.AnnualReportTab })));
const CashflowReportTab = lazy(() => import('./CashflowReportTab').then((m) => ({ default: m.CashflowReportTab })));

type Tab = 'expenses' | 'annual' | 'cashflow';
const TABS: Tab[] = ['expenses', 'annual', 'cashflow'];

const Loading: React.FC = () => (
  <p className="text-center text-slate-400 py-10">
    <Loader2 size={18} className="inline animate-spin mr-2" /> Carregando…
  </p>
);

/**
 * Finanças → Relatórios: abas Despesas do mês (por categoria, com drill-down), Anual (categorias ×
 * meses) e Fluxo de caixa (saldo por mês, realizado × projetado). A aba vai na URL (`?tab=`).
 */
export const ReportsView: React.FC = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const param = searchParams.get('tab') as Tab | null;
  const tab: Tab = param && TABS.includes(param) ? param : 'expenses';

  const setTab = (id: string) => {
    const next = new URLSearchParams(searchParams);
    next.set('tab', id);
    setSearchParams(next, { replace: true });
  };

  return (
    <div className="space-y-4">
      <h1 className="text-h3 flex items-center gap-2">
        <BarChart3 size={20} className="text-slate-500" /> Relatórios
      </h1>

      <PillTabs
        tabs={[
          { id: 'expenses', label: 'Despesas do mês', icon: <PieChart size={15} /> },
          { id: 'annual', label: 'Anual', icon: <CalendarRange size={15} /> },
          { id: 'cashflow', label: 'Fluxo de caixa', icon: <TrendingUp size={15} /> },
        ]}
        active={tab}
        onChange={setTab}
      />

      <Suspense fallback={<Loading />}>
        {tab === 'expenses' && <ExpensesReportTab />}
        {tab === 'annual' && <AnnualReportTab />}
        {tab === 'cashflow' && <CashflowReportTab />}
      </Suspense>
    </div>
  );
};

export default ReportsView;
